import React, { useEffect, useMemo, useState } from "react";

import {

  collection,

  doc,

  getDoc,

  getDocs,

  query,

  limit,

  addDoc,

  writeBatch,

  orderBy,

} from "firebase/firestore";

import { db } from "../firebase";
import * as XLSX from "xlsx";



/* ===================== Config ===================== */



const ENDPOINT_CALC = "https://calcrotationnowfarmacias-ieitjwau4a-uc.a.run.app";

const ENDPOINT_APPLY = "https://applyrotationrun-ieitjwau4a-uc.a.run.app";



// ✅ Nombres reales de sucursales

const SUCURSALES = {

  "1": "Moscovich",

  "2": "Guberman",

  "3": "Sunchales",

};



const DEFAULT_PAGE_SIZE = 50;



/* ===================== Helpers ===================== */



function safeNum(n, def = 0) {

  const x = Number(n);

  return Number.isFinite(x) ? x : def;

}



function fmt(n) {

  const x = safeNum(n, 0);

  return x.toLocaleString("es-AR");

}



function clampStr(s) {

  return String(s ?? "").trim();

}



function downloadTextFile(filename, text, mime = "text/csv;charset=utf-8") {

  const blob = new Blob([text], { type: mime });

  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");

  a.href = url;

  a.download = filename;

  a.click();

  URL.revokeObjectURL(url);

}



function toCSV(rows, headers) {

  const SEP = ";"; // ✅ separador compatible con Excel es-AR



  const esc = (v) => {

    const s = String(v ?? "");

    // si contiene ; " o salto de línea → escapamos

    if (/[;"\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;

    return s;

  };



  const head = headers.map(esc).join(SEP);

  const body = rows

    .map((r) => headers.map((h) => esc(r[h])).join(SEP))

    .join("\n");



  return `${head}\n${body}\n`;

}





function sumTransfersQty(item) {

  const arr = Array.isArray(item?.transfers) ? item.transfers : [];

  return arr.reduce((a, t) => a + safeNum(t.qty, 0), 0);

}



function transfersToString(item) {

  const arr = Array.isArray(item?.transfers) ? item.transfers : [];

  if (!arr.length) return "";

  return arr.map((t) => `${SUCURSALES[String(t.fromSuc)] || t.fromSuc}→${SUCURSALES[String(t.toSuc)] || t.toSuc} (${t.qty})`).join(" | ");

}



function buildRouteSummary(items) {

  const map = new Map();

  for (const it of items) {

    const arr = Array.isArray(it?.transfers) ? it.transfers : [];

    for (const t of arr) {

      const from = String(t.fromSuc);

      const to = String(t.toSuc);

      const qty = safeNum(t.qty, 0);

      if (!from || !to || qty <= 0) continue;

      const key = `${from}->${to}`;

      map.set(key, (map.get(key) || 0) + qty);

    }

  }

  return Array.from(map.entries())

    .map(([k, qty]) => ({ route: k, qty }))

    .sort((a, b) => b.qty - a.qty);

}



function buildPickingByOrigin(items) {

  const out = { "1": [], "2": [], "3": [] };



  for (const it of items) {

    const sku = clampStr(it.sku);
    const cb = clampStr(it.cb);

    const desc = clampStr(it.descripcionDisplay || it.descripcion);

    const pk = clampStr(it.productKey);

        const lab = clampStr(it.laboratorio);





    const arr = Array.isArray(it?.transfers) ? it.transfers : [];

    for (const t of arr) {

      const from = String(t.fromSuc);

      const to = String(t.toSuc);

      const qty = safeNum(t.qty, 0);

      if (!from || !to || qty <= 0) continue;



      if (!out[from]) out[from] = [];

      out[from].push({

        productKey: pk,

        sku,
        cb: clampStr(it.cb),

        descripcion: desc,

           laboratorio: lab,

        cantidad: qty,

        destino: SUCURSALES[to] ? `${SUCURSALES[to]} (${to})` : String(to),

      });

    }

  }



  for (const k of Object.keys(out)) {

    out[k].sort((a, b) =>

      (a.descripcion || "").localeCompare(b.descripcion || "", "es", { sensitivity: "base", numeric: true })

    );

  }

  return out;

}



/* ===================== Component ===================== */



export default function RotacionScreen() {

  // Run summary

  const [runId, setRunId] = useState("");

  const [runSummary, setRunSummary] = useState(null);



  // Items

  const [items, setItems] = useState([]);

  const [itemsLoading, setItemsLoading] = useState(false);



  // Calc / apply

  const [calcLoading, setCalcLoading] = useState(false);

  const [applyLoading, setApplyLoading] = useState(false);



  // Save selected

  const [saveLoading, setSaveLoading] = useState(false);



  // Errors / info

  const [error, setError] = useState("");

  const [info, setInfo] = useState("");



  // UI filters

  const [qText, setQText] = useState("");

  const [onlyWithTransfers, setOnlyWithTransfers] = useState(true);

  const [minUnitsToMove, setMinUnitsToMove] = useState(2);

  const [filterFromSuc, setFilterFromSuc] = useState(""); // "1" | "2" | "3" | ""

  const [filterToSuc, setFilterToSuc] = useState("");

    const [filterLab, setFilterLab] = useState(""); // filtro por laboratorio
  // Selección independiente para el nuevo Excel de rotación consolidada
  const [labsExcel, setLabsExcel] = useState(() => new Set());
  const [labExcelSearch, setLabExcelSearch] = useState("");















  // Paging

  const [page, setPage] = useState(1);

  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);



  // Expanded row

  const [expandedPk, setExpandedPk] = useState("");



  // Selection (por productKey)

  const [selected, setSelected] = useState(() => new Set());



  // Params for calculation

  const [windowDays, setWindowDays] = useState(60);

  const [reserveSalesDays, setReserveSalesDays] = useState(30); // ✅ o windowDays

  const [keepDays, setKeepDays] = useState(3);

  const [minTransferQty, setMinTransferQty] = useState(1);

  const [minStockTotal, setMinStockTotal] = useState(2);

  const [sucs, setSucs] = useState({ "1": true, "2": true, "3": true });



  // Historial guardados

  const [savedList, setSavedList] = useState([]);

  const [savedLoading, setSavedLoading] = useState(false);



  const activeSucList = useMemo(() => {

    const out = [];

    for (const sid of ["1", "2", "3"]) if (sucs[sid]) out.push(sid);

    return out.length ? out : ["1", "2", "3"];

  }, [sucs]);



  function resetViewForNewRun() {
    setLabsExcel(new Set());

    setRunSummary(null);

    setItems([]);

    setExpandedPk("");

    setPage(1);

    setSelected(new Set());

  }



  async function calcNow() {

    setError("");

    setInfo("");

    setCalcLoading(true);

    resetViewForNewRun();



    try {

      const resp = await fetch(ENDPOINT_CALC, {

        method: "POST",

        mode: "cors",

        headers: { "Content-Type": "application/json" },

        body: JSON.stringify({

          windowDays: Number(windowDays) || 30,

          reserveSalesDays: Number(reserveSalesDays) || 0,

          keepDays: Number(keepDays) || 3,

          minTransferQty: Number(minTransferQty) || 2,

          minStockTotal: Number(minStockTotal) || 3,

          sucursales: activeSucList,

          save: true,

        }),

      });



      const data = await resp.json();

      if (!resp.ok || !data.ok) throw new Error(data.error || "Error al calcular rotación");



      setRunId(data.runId || "");

      setRunSummary(data);

      setInfo("Run calculado. Podés cargar items y seleccionar movimientos a guardar/exportar.");

    } catch (e) {

      setError(e?.message || String(e));

    } finally {

      setCalcLoading(false);

    }

  }



  async function loadRunSummaryAndItems(rid) {
    setLabsExcel(new Set());

    if (!rid) return;

    setError("");

    setInfo("");

    setItemsLoading(true);

    setItems([]);

    setExpandedPk("");

    setPage(1);

    setSelected(new Set());



    try {

      // summary

      const ref = doc(db, "rotaciones_runs", rid);

      const snap = await getDoc(ref);

      if (!snap.exists()) throw new Error("No existe el runId en rotaciones_runs");

      const sum = { runId: rid, ...snap.data() };

      setRunSummary(sum);



      // items

      const itemsRef = collection(db, "rotaciones_runs", rid, "items");

      const qy = query(itemsRef, limit(5000));

      const isnap = await getDocs(qy);



      const list = isnap.docs.map((d) => ({ id: d.id, ...d.data() }));

      list.sort(

        (a, b) =>

          safeNum(b.totalSuggestedMove, sumTransfersQty(b)) -

          safeNum(a.totalSuggestedMove, sumTransfersQty(a))

      );

      setItems(list);

      setInfo(`Items cargados: ${list.length}. Seleccioná los movimientos que quieras guardar/exportar.`);

    } catch (e) {

      setError(e?.message || String(e));

    } finally {

      setItemsLoading(false);

    }

  }



  async function applyRun() {

    setError("");

    setInfo("");

    if (!runId) {

      setError("No hay runId. Primero calculá o cargá un run.");

      return;

    }

    setApplyLoading(true);



    try {

      const resp = await fetch(ENDPOINT_APPLY, {

        method: "POST",

        mode: "cors",

        headers: { "Content-Type": "application/json" },

        body: JSON.stringify({ runId }),

      });

      const data = await resp.json();

      if (!resp.ok || !data.ok) throw new Error(data.error || "Error aplicando run");

      setInfo(`Órdenes internas generadas OK. ${data.message || ""}`);

    } catch (e) {

      setError(e?.message || String(e));

    } finally {

      setApplyLoading(false);

    }

  }



  /* ===================== Filtro / paginado ===================== */



  const labOptions = useMemo(() => {

    const set = new Set();

    for (const it of items) {

      const lab = clampStr(it.laboratorio);

      if (lab) set.add(lab);

    }

    return Array.from(set).sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }));

  }, [items]);





  const filtered = useMemo(() => {

    const q = clampStr(qText).toLowerCase();

    const fromF = clampStr(filterFromSuc);

    const toF = clampStr(filterToSuc);



    return items.filter((it) => {



            const lab = clampStr(it.laboratorio).toLowerCase();

      const labF = clampStr(filterLab).toLowerCase();

      const desc = clampStr(it.descripcionDisplay || it.descripcion).toLowerCase();

      const sku = clampStr(it.sku).toLowerCase();
    const cb = clampStr(it.cb).toLowerCase();

      const pk = clampStr(it.productKey).toLowerCase();



      const move = safeNum(it.totalSuggestedMove, sumTransfersQty(it));

      const hasTransfers = Array.isArray(it.transfers) && it.transfers.length > 0;



      if (onlyWithTransfers && !hasTransfers) return false;

      if (move < safeNum(minUnitsToMove, 0)) return false;



      if (q) {

        if (!desc.includes(q) && !sku.includes(q) && !cb.includes(q) && !pk.includes(q)) return false;

      }



      if (fromF || toF) {

        const arr = Array.isArray(it.transfers) ? it.transfers : [];

        const any = arr.some((t) => {

          const from = String(t.fromSuc || "");

          const to = String(t.toSuc || "");

          if (fromF && from !== fromF) return false;

          if (toF && to !== toF) return false;

          return true;

        });

        if (!any) return false;

      }



            if (labF && lab !== labF) return false;





      return true;

    });

  }, [items, qText, onlyWithTransfers, minUnitsToMove, filterFromSuc, filterToSuc,filterLab]);



  const selectedItems = useMemo(() => {

    const s = selected;

    return filtered.filter((it) => s.has(clampStr(it.productKey)));

  }, [filtered, selected]);



  const routeSummary = useMemo(() => buildRouteSummary(filtered), [filtered]);



  const totals = useMemo(() => {

    const unitsToMove = filtered.reduce((a, it) => a + safeNum(it.totalSuggestedMove, sumTransfersQty(it)), 0);

    const transfers = filtered.reduce((a, it) => a + (Array.isArray(it.transfers) ? it.transfers.length : 0), 0);

    return { unitsToMove, transfers, rows: filtered.length };

  }, [filtered]);



  const totalsSelected = useMemo(() => {

    const unitsToMove = selectedItems.reduce((a, it) => a + safeNum(it.totalSuggestedMove, sumTransfersQty(it)), 0);

    const transfers = selectedItems.reduce((a, it) => a + (Array.isArray(it.transfers) ? it.transfers.length : 0), 0);

    return { unitsToMove, transfers, rows: selectedItems.length };

  }, [selectedItems]);



  const pages = useMemo(() => {

    const total = filtered.length;

    const ps = Math.max(1, Number(pageSize) || DEFAULT_PAGE_SIZE);

    const maxPage = Math.max(1, Math.ceil(total / ps));

    const p = Math.min(maxPage, Math.max(1, page));

    const start = (p - 1) * ps;

    const end = start + ps;

    return { maxPage, p, start, end, ps };

  }, [filtered.length, pageSize, page]);



  const paged = useMemo(() => filtered.slice(pages.start, pages.end), [filtered, pages.start, pages.end]);



  /* ===================== Export helpers (lista arbitraria) ===================== */



  function exportResumenCSVFor(list, suffix = "") {

    const rows = list.map((it) => {

      const pk = clampStr(it.productKey);

      const sku = clampStr(it.sku);

      const desc = clampStr(it.descripcionDisplay || it.descripcion);

      const move = safeNum(it.totalSuggestedMove, sumTransfersQty(it));



      const s1v = safeNum(it.salesBySuc?.["1"], 0);

      const s2v = safeNum(it.salesBySuc?.["2"], 0);

      const s3v = safeNum(it.salesBySuc?.["3"], 0);



      const st1 = safeNum(it.stockBySuc?.["1"], 0);

      const st2 = safeNum(it.stockBySuc?.["2"], 0);

      const st3 = safeNum(it.stockBySuc?.["3"], 0);



      // const t1 = safeNum(it.targetBySuc?.["1"], 0);

      // const t2 = safeNum(it.targetBySuc?.["2"], 0);

      // const t3 = safeNum(it.targetBySuc?.["3"], 0);



      // const mk1 = safeNum(it.minKeepBySuc?.["1"], 0);

      // const mk2 = safeNum(it.minKeepBySuc?.["2"], 0);

      // const mk3 = safeNum(it.minKeepBySuc?.["3"], 0);



      const d1 = safeNum(it.desiredBySuc?.["1"], 0);

const d2 = safeNum(it.desiredBySuc?.["2"], 0);

const d3 = safeNum(it.desiredBySuc?.["3"], 0);



            const lab = clampStr(it.laboratorio);





      return {

         laboratorio: lab,

        productKey: pk,

        sku,
        cb: clampStr(it.cb),

        descripcion: desc,

        ventas_moscovich: s1v,

        ventas_guberman: s2v,

        ventas_sunchales: s3v,

        stock_moscovich: st1,

        stock_guberman: st2,

        stock_sunchales: st3,

        // target_moscovich: t1,

        // target_guberman: t2,

        // target_sunchales: t3,

        // minKeep_moscovich: mk1,

        // minKeep_guberman: mk2,

        // minKeep_sunchales: mk3,

        ideal_moscovich: d1,

ideal_guberman: d2,

ideal_sunchales: d3,

        unidades_a_mover: move,

        transfers: transfersToString(it),

      };

    });



    const headers = [

      "productKey",

      "sku",
      "cb",

      "descripcion",

         "laboratorio",

      "ventas_moscovich",

      "ventas_guberman",

      "ventas_sunchales",

      "stock_moscovich",

      "stock_guberman",

      "stock_sunchales",

      // "target_moscovich",

      // "target_guberman",

      // "target_sunchales",

      // "minKeep_moscovich",

      // "minKeep_guberman",

      // "minKeep_sunchales",

      "ideal_moscovich",

"ideal_guberman",

"ideal_sunchales",

      "unidades_a_mover",

      "transfers",

    ];



    const csv = toCSV(rows, headers);

    downloadTextFile(`rotacion_resumen_${runId || "run"}${suffix}.csv`, csv);

  }



  function exportPickingCSVFor(list, suffix = "") {

    const picking = buildPickingByOrigin(list);



    for (const sid of Object.keys(picking)) {

      const rows = picking[sid] || [];

      if (!rows.length) continue;



      const headers = ["sku", "cb", "descripcion", "laboratorio", "cantidad", "destino", "productKey"];





      const csv = toCSV(rows, headers);

      downloadTextFile(

        `rotacion_picking_origen_${SUCURSALES[sid] || sid}_${runId || "run"}${suffix}.csv`,

        csv

      );

    }

  }



  function exportSelectedResumenCSV() {

    if (!selectedItems.length) return;

    exportResumenCSVFor(selectedItems, "_SELECCION");

  }

  function exportSelectedPickingCSV() {

    if (!selectedItems.length) return;

    exportPickingCSVFor(selectedItems, "_SELECCION");

  }



  /* ===================== Selección ===================== */



  function toggleSelected(pk) {

    setSelected((prev) => {

      const next = new Set(prev);

      if (next.has(pk)) next.delete(pk);

      else next.add(pk);

      return next;

    });

  }



  function selectAllOnPage() {

    setSelected((prev) => {

      const next = new Set(prev);

      for (const it of paged) {

        const pk = clampStr(it.productKey);

        if (pk) next.add(pk);

      }

      return next;

    });

  }



  function clearSelection() {

    setSelected(new Set());

  }



  function selectAllFiltered() {

    setSelected((prev) => {

      const next = new Set(prev);

      for (const it of filtered) {

        const pk = clampStr(it.productKey);

        if (pk) next.add(pk);

      }

      return next;

    });

  }



  /* ===================== Guardar Movimientos seleccionados ===================== */



  async function saveSelectedMovements() {

    setError("");

    setInfo("");



    if (!runId) {

      setError("No hay runId cargado. Primero calculá o cargá un run.");

      return;

    }

    if (!selectedItems.length) {

      setError("No hay movimientos seleccionados.");

      return;

    }



    setSaveLoading(true);

    try {

      // 1) crear doc principal

      const payload = {

        createdAt: Date.now(),

        runId,

        params: runSummary?.params || {

          windowDays: Number(windowDays) || null,

          keepDays: Number(keepDays) || null,

          minTransferQty: Number(minTransferQty) || null,

          minStockTotal: Number(minStockTotal) || null,

          sucursales: activeSucList,

        },

        period: runSummary?.period || null,

        totals: {

          rows: selectedItems.length,

          transfers: totalsSelected.transfers,

          unitsToMove: totalsSelected.unitsToMove,

        },

      };



      const movRef = await addDoc(collection(db, "rotaciones_movimientos"), payload);



      // 2) escribir ítems en subcolección (batch por chunks)

      // guardamos una versión “ligera” de cada item para poder reconstruir exports

      const CHUNK = 400; // batch hasta \~500 writes (dejamos margen)

      for (let i = 0; i < selectedItems.length; i += CHUNK) {

        const slice = selectedItems.slice(i, i + CHUNK);

        const batch = writeBatch(db);



        slice.forEach((it) => {

          const pk = clampStr(it.productKey) || it.id || String(Math.random());

          const ref = doc(db, "rotaciones_movimientos", movRef.id, "items", pk);



          batch.set(ref, {

            productKey: clampStr(it.productKey),

            sku: clampStr(it.sku),
            ...(clampStr(it.cb) ? { cb: clampStr(it.cb) } : {}),

            descripcion: clampStr(it.descripcionDisplay || it.descripcion),

                        laboratorio: clampStr(it.laboratorio),

            salesBySuc: it.salesBySuc || null,

            stockBySuc: it.stockBySuc || null,

            targetBySuc: it.targetBySuc || null,

            minKeepBySuc: it.minKeepBySuc || null,

            totalSuggestedMove: safeNum(it.totalSuggestedMove, sumTransfersQty(it)),

            transfers: Array.isArray(it.transfers) ? it.transfers : [],

            createdAt: Date.now(),

          });

        });



        await batch.commit();

      }



      setInfo(`Movimientos guardados ✅ (ID: ${movRef.id}).`);

      await loadSavedHistory();

    } catch (e) {

      setError(e?.message || String(e));

    } finally {

      setSaveLoading(false);

    }

  }



  /* ===================== Historial ===================== */



  async function loadSavedHistory() {

    setSavedLoading(true);

    try {

      const qy = query(

        collection(db, "rotaciones_movimientos"),

        orderBy("createdAt", "desc"),

        limit(20)

      );

      const snap = await getDocs(qy);

      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

      setSavedList(list);

    } catch (e) {

      // no rompemos la pantalla si falla historial

      console.error(e);

    } finally {

      setSavedLoading(false);

    }

  }



  useEffect(() => {

    loadSavedHistory();

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);



  async function loadSavedSelection(savedId) {
    setLabsExcel(new Set());

    setError("");

    setInfo("");

    try {

      setItemsLoading(true);



      // traer items del guardado

      const itemsRef = collection(db, "rotaciones_movimientos", savedId, "items");

      const qy = query(itemsRef, limit(5000));

      const snap = await getDocs(qy);

      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));



      // si querés, mantenemos el listado actual (del run) y solo marcamos selección.

      // pero si no hay items cargados, te cargamos list como items.

      if (!items.length) {

        setItems(list);

      }



      // marcar selección por productKey (o id)

      const next = new Set();

      list.forEach((it) => {

        const pk = clampStr(it.productKey || it.id);

        if (pk) next.add(pk);

      });

      setSelected(next);



      setInfo(`Selección cargada desde historial (${savedId}).`);

    } catch (e) {

      setError(e?.message || String(e));

    } finally {

      setItemsLoading(false);

    }

  }



  async function exportSavedCSVs(savedId, type) {

    setError("");

    setInfo("");

    try {

      const itemsRef = collection(db, "rotaciones_movimientos", savedId, "items");

      const qy = query(itemsRef, limit(5000));

      const snap = await getDocs(qy);

      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));



      const suffix = `_GUARDADO_${savedId.slice(0, 8)}`;



      if (type === "resumen") exportResumenCSVFor(list, suffix);

      if (type === "picking") exportPickingCSVFor(list, suffix);



      setInfo(`CSV ${type} generado para guardado ${savedId}.`);

    } catch (e) {

      setError(e?.message || String(e));

    }

  }



  /* ===================== Excel de rotación por varios laboratorios ===================== */

  const excelLabResults = items.filter((it) =>
    labsExcel.has(clampStr(it.laboratorio)) && sumTransfersQty(it) > 0
  );

  function toggleExcelLab(lab) {
    setLabsExcel((prev) => {
      const next = new Set(prev);
      if (next.has(lab)) next.delete(lab);
      else next.add(lab);
      return next;
    });
  }

  function exportExcelLaboratorios() {
    if (!excelLabResults.length) {
      setError("Seleccioná al menos un laboratorio con movimientos de rotación.");
      return;
    }

    setError("");
    // Un solo Excel por sucursal de ORIGEN: muestra lo que cada farmacia debe preparar y enviar.
    // Los movimientos hacia esa farmacia figuran en el archivo de la farmacia de origen.
    const porOrigen = { "1": [], "2": [], "3": [] };
    for (const it of excelLabResults) {
      for (const t of Array.isArray(it.transfers) ? it.transfers : []) {
        const origen = String(t.fromSuc || "");
        const destino = String(t.toSuc || "");
        const cantidad = safeNum(t.qty, 0);
        if (!porOrigen[origen] || !destino || cantidad <= 0) continue;
        porOrigen[origen].push({
          Laboratorio: clampStr(it.laboratorio),
          SKU: clampStr(it.sku),
          CB: clampStr(it.cb),
          "Descripción": clampStr(it.descripcionDisplay || it.descripcion),
          "Sucursal origen": SUCURSALES[origen] || origen,
          "Sucursal destino": SUCURSALES[destino] || destino,
          "Cantidad a mover": cantidad,
          "Stock origen": safeNum(it.stockBySuc?.[origen]),
          "Stock destino": safeNum(it.stockBySuc?.[destino]),
          "ProductKey": clampStr(it.productKey),
        });
      }
    }

    const columnas = [
      "Laboratorio", "SKU", "CB", "Descripción", "Sucursal origen",
      "Sucursal destino", "Cantidad a mover", "Stock origen", "Stock destino", "ProductKey",
    ];
    const ancho = [27, 19, 21, 58, 21, 21, 19, 16, 16, 28];
    const fecha = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    let archivosConMovimientos = 0;
    let transferencias = 0;
    let unidades = 0;

    // Se generan exactamente TRES archivos independientes, no un libro con tres hojas.
    for (const sid of ["1", "2", "3"]) {
      const rows = porOrigen[sid].sort((a, b) =>
        a.Laboratorio.localeCompare(b.Laboratorio, "es", { sensitivity: "base" }) ||
        a["Sucursal destino"].localeCompare(b["Sucursal destino"], "es") ||
        a["Descripción"].localeCompare(b["Descripción"], "es", { sensitivity: "base" })
      );
      const ws = XLSX.utils.json_to_sheet(rows, { header: columnas });
      ws["!cols"] = ancho.map((wch) => ({ wch }));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Rotación");
      XLSX.writeFile(wb, `rotacion_${SUCURSALES[sid]}_${fecha}.xlsx`, { bookType: "xlsx" });
      if (rows.length) archivosConMovimientos++;
      transferencias += rows.length;
      unidades += rows.reduce((sum, r) => sum + Number(r["Cantidad a mover"] || 0), 0);
    }
    setInfo(
      `Se descargaron 3 Excel (uno por sucursal). ${archivosConMovimientos} sucursales con movimientos, ` +
      `${transferencias} transferencias y ${unidades} unidades entre ${labsExcel.size} laboratorios seleccionados.`
    );
  }

  /* ===================== UI ===================== */



  return (

    <div className="p-6">

      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between mb-4">

        <div>

          <h1 className="text-3xl font-bold">Rotación inteligente</h1>

          <div className="text-sm opacity-70">

            Distribución óptima según ventas — seleccioná movimientos, exportá CSV o guardalos en historial.

          </div>

        </div>



        <div className="flex gap-2 flex-wrap">

          <button className="btn btn-outline btn-sm" onClick={loadSavedHistory} disabled={savedLoading}>

            {savedLoading ? "Actualizando..." : "Actualizar historial"}

          </button>

        </div>

      </div>



      {/* Alertas */}

      {!!error && (

        <div className="alert alert-error mb-4">

          <span>{error}</span>

        </div>

      )}

      {!!info && (

        <div className="alert alert-info mb-4">

          <span>{info}</span>

        </div>

      )}



      {/* Panel principal */}

      <div className="bg-base-100 p-4 rounded shadow mb-6">

        <div className="flex flex-col gap-3">

          {/* Acciones */}

          <div className="flex flex-col md:flex-row md:items-center gap-3 justify-between">

            <div className="flex gap-2 flex-wrap items-center">

              <button className="btn btn-primary" onClick={calcNow} disabled={calcLoading}>

                {calcLoading ? "Calculando..." : "Calcular rotación ahora"}

              </button>



              {/* <button className="btn btn-outline" onClick={applyRun} disabled={!runId || applyLoading}>

                {applyLoading ? "Aplicando..." : "Generar órdenes internas"}

              </button> */}

            </div>



            <div className="flex gap-2 flex-wrap items-center">

              <button

                className="btn btn-success"

                onClick={saveSelectedMovements}

                disabled={saveLoading || !selectedItems.length}

                title="Guarda los movimientos seleccionados en Firestore (historial) con sus items"

              >

                {saveLoading ? "Guardando..." : `Guardar seleccionados (${selectedItems.length})`}

              </button>



              <button

                className="btn btn-outline"

                onClick={exportSelectedResumenCSV}

                disabled={!selectedItems.length}

              >

                CSV Resumen (selección)

              </button>



              <button

                className="btn btn-outline"

                onClick={exportSelectedPickingCSV}

                disabled={!selectedItems.length}

              >

                CSV Picking (selección)

              </button>

            </div>

          </div>



          {/* Parámetros */}

          <div className="divider my-1" />



          <div className="flex flex-col md:flex-row md:items-center gap-3 flex-wrap">

            <div className="flex flex-wrap items-center gap-3">

              <label className="text-sm">

                Ventana (días)

                <input

                  className="input input-bordered input-sm ml-2 w-24"

                  value={windowDays}

                  onChange={(e) => setWindowDays(e.target.value)}

                />

              </label>



              <label className="text-sm">

  Piso por ventas (días)

  <input

    className="input input-bordered input-sm ml-2 w-24"

    value={reserveSalesDays}

    onChange={(e) => setReserveSalesDays(e.target.value)}

    placeholder="0"

    title="0 = no aplicar piso por ventas. Si ponés 30, conserva ventas de los últimos 30 días (aunque windowDays sea 90)."

  />

</label>



              {/* <label className="text-sm">

                Keep (días)

                <input

                  className="input input-bordered input-sm ml-2 w-24"

                  value={keepDays}

                  onChange={(e) => setKeepDays(e.target.value)}

                />

              </label> */}



              <label className="text-sm">

                Min transfer

                <input

                  className="input input-bordered input-sm ml-2 w-24"

                  value={minTransferQty}

                  onChange={(e) => setMinTransferQty(e.target.value)}

                />

              </label>



              <label className="text-sm">

                Min stock total

                <input

                  className="input input-bordered input-sm ml-2 w-28"

                  value={minStockTotal}

                  onChange={(e) => setMinStockTotal(e.target.value)}

                />

              </label>

            </div>



            <div className="flex flex-wrap items-center gap-2 md:ml-auto text-sm">

              <span className="font-medium">Sucursales:</span>

              {["1", "2", "3"].map((sid) => (

                <label key={sid} className="flex items-center gap-2">

                  <input

                    type="checkbox"

                    className="checkbox checkbox-success checkbox-xs"

                    checked={!!sucs[sid]}

                    onChange={(e) => setSucs((p) => ({ ...p, [sid]: e.target.checked }))}

                  />

                  <span>{SUCURSALES[sid]}</span>

                </label>

              ))}

            </div>

          </div>



          {/* Cargar run */}

          <div className="divider my-1" />



          <div className="flex flex-col md:flex-row md:items-center gap-2">

            <input

              className="input input-bordered w-full md:w-[420px]"

              value={runId}

              onChange={(e) => setRunId(e.target.value)}

              placeholder="runId para cargar uno anterior (rotaciones_runs)"

            />

            <button

              className="btn btn-outline"

              onClick={() => loadRunSummaryAndItems(runId)}

              disabled={!runId || itemsLoading}

            >

              {itemsLoading ? "Cargando..." : "Cargar run"}

            </button>



            {/* <div className="text-sm opacity-70 md:ml-auto">

              <b>Seleccionados:</b> {fmt(totalsSelected.rows)} · <b>Transfers:</b>{" "}

              {fmt(totalsSelected.transfers)} · <b>Unidades:</b> {fmt(totalsSelected.unitsToMove)}

            </div> */}

          </div>

        </div>

      </div>



      {/* Summary run */}

      {runSummary && (

        <div className="bg-base-100 p-4 rounded shadow mb-6">

          <div className="flex flex-wrap gap-3 text-sm">

            <span className="badge">Run: {runId}</span>

            <span className="badge badge-outline">

              Período: {runSummary.period?.start || "-"} → {runSummary.period?.end || "-"}

            </span>

            <span className="badge badge-outline">

              Sucursales: {(runSummary.params?.sucursales || []).map((s) => SUCURSALES[String(s)] || s).join(", ")}

            </span>

            <span className="badge badge-outline">

              SKUs con rotación: {fmt(runSummary.totals?.skusWithTransfers)}

            </span>

            <span className="badge badge-outline">Transfers: {fmt(runSummary.totals?.transfers)}</span>

            <span className="badge badge-outline">

              Unidades a mover: {fmt(runSummary.totals?.unitsToMove)}

            </span>

          </div>

        </div>

      )}



  {/* Nueva exportación consolidada (independiente de la selección de ítems) */}
  <div className="bg-base-100 p-4 rounded shadow mb-6">
    <h2 className="text-xl font-semibold mb-1">Excel de rotación por laboratorios</h2>
    <p className="text-sm opacity-70 mb-3">
      Seleccioná varios laboratorios del cálculo cargado y descargá tres Excel independientes: uno para Moscovich, otro para Guberman y otro para Sunchales. Cada archivo reúne los movimientos que salen de esa sucursal, con el CB cuando exista. No crea órdenes ni modifica el stock.
    </p>
    <div className="flex flex-wrap gap-2 mb-3">
      <input className="input input-bordered input-sm w-full md:w-72"
        value={labExcelSearch} onChange={e => setLabExcelSearch(e.target.value)}
        placeholder="Buscar laboratorio" />
      <button className="btn btn-outline btn-sm"
        onClick={() => setLabsExcel(new Set(labOptions))} disabled={!labOptions.length}>
        Seleccionar todos
      </button>
      <button className="btn btn-outline btn-sm"
        onClick={() => setLabsExcel(new Set())} disabled={!labsExcel.size}>
        Limpiar selección
      </button>
    </div>
    <div className="border rounded p-3 max-h-56 overflow-y-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mb-3">
      {labOptions.filter(l => l.toLowerCase().includes(labExcelSearch.trim().toLowerCase())).map(l => (
        <label key={l} className="flex items-center gap-2 text-sm cursor-pointer">
          <input type="checkbox" className="checkbox checkbox-sm checkbox-success"
            checked={labsExcel.has(l)} onChange={() => toggleExcelLab(l)} />
          <span>{l}</span>
        </label>
      ))}
      {!labOptions.length && <span className="text-sm opacity-70">Primero calculá la rotación o cargá un run.</span>}
    </div>
    <div className="flex flex-wrap gap-3 items-center">
      <span className="text-sm opacity-70">
        {labsExcel.size} laboratorios · {excelLabResults.length} productos ·
        {excelLabResults.reduce((s,it) => s + sumTransfersQty(it), 0)} unidades a mover
      </span>
      <button className="btn btn-primary" disabled={!excelLabResults.length}
        onClick={exportExcelLaboratorios}>Descargar 3 Excel por sucursal</button>
    </div>
  </div>

 {/* Filtros + selección rápida */}

<div className="bg-base-100 p-4 rounded shadow mb-6">

  <div className="flex items-center justify-between mb-3">

    <h2 className="text-xl font-semibold">Filtros y búsqueda</h2>

    <span className="text-sm opacity-70">

      Refiná los resultados antes de seleccionar movimientos

    </span>

  </div>



        <div className="flex flex-col gap-3">

          <div className="flex flex-col md:flex-row md:items-center gap-3 justify-between">

            <div className="flex flex-wrap gap-2 items-center">

              <input

                className="input input-bordered w-full md:w-[420px]"

                value={qText}

                onChange={(e) => {

                  setQText(e.target.value);

                  setPage(1);

                }}

                placeholder="Buscar por SKU / CB / descripción / productKey"

              />



              <label className="flex items-center gap-2 text-sm">

                <input

                  type="checkbox"

                  className="checkbox checkbox-xs"

                  checked={onlyWithTransfers}

                  onChange={(e) => {

                    setOnlyWithTransfers(e.target.checked);

                    setPage(1);

                  }}

                />

                Solo con transfers

              </label>



              <label className="text-sm">

                Mín unidades a mover

                <input

                  className="input input-bordered input-sm ml-2 w-24"

                  value={minUnitsToMove}

                  onChange={(e) => {

                    setMinUnitsToMove(e.target.value);

                    setPage(1);

                  }}

                />

              </label>



                            <label className="text-sm">

                Laboratorio

                <select

                  className="select select-bordered select-sm ml-2"

                  value={filterLab}

                  onChange={(e) => {

                    setFilterLab(e.target.value);

                    setPage(1);

                  }}

                >

                  <option value="">(cualquiera)</option>

                  {labOptions.map((l) => (

                    <option key={l} value={l}>

                      {l}

                    </option>

                  ))}

                </select>

              </label>





              <label className="text-sm">

                Origen

                <select

                  className="select select-bordered select-sm ml-2"

                  value={filterFromSuc}

                  onChange={(e) => {

                    setFilterFromSuc(e.target.value);

                    setPage(1);

                  }}

                >

                  <option value="">(cualquiera)</option>

                  <option value="1">{SUCURSALES["1"]}</option>

                  <option value="2">{SUCURSALES["2"]}</option>

                  <option value="3">{SUCURSALES["3"]}</option>

                </select>

              </label>



              <label className="text-sm">

                Destino

                <select

                  className="select select-bordered select-sm ml-2"

                  value={filterToSuc}

                  onChange={(e) => {

                    setFilterToSuc(e.target.value);

                    setPage(1);

                  }}

                >

                  <option value="">(cualquiera)</option>

                  <option value="1">{SUCURSALES["1"]}</option>

                  <option value="2">{SUCURSALES["2"]}</option>

                  <option value="3">{SUCURSALES["3"]}</option>

                </select>

              </label>

            </div>



            <div className="flex flex-wrap gap-2 items-center">

              <button className="btn btn-outline btn-sm" onClick={selectAllOnPage} disabled={!paged.length}>

                Seleccionar página

              </button>

              <button className="btn btn-outline btn-sm" onClick={selectAllFiltered} disabled={!filtered.length}>

                Seleccionar filtrados

              </button>

              <button className="btn btn-outline btn-sm" onClick={clearSelection} disabled={!selected.size}>

                Limpiar selección

              </button>



              <label className="text-sm ml-2">

                Page size

                <select

                  className="select select-bordered select-sm ml-2"

                  value={pageSize}

                  onChange={(e) => {

                    setPageSize(Number(e.target.value));

                    setPage(1);

                  }}

                >

                  <option value={25}>25</option>

                  <option value={50}>50</option>

                  <option value={100}>100</option>

                  <option value={200}>200</option>

                </select>

              </label>

            </div>

          </div>



          <div className="text-sm opacity-70">

            <b>Filtrados:</b> {fmt(totals.rows)} · <b>Transfers:</b> {fmt(totals.transfers)} · <b>Unidades:</b>{" "}

            {fmt(totals.unitsToMove)}

          </div>

        </div>

      </div>



      {/* Resumen por ruta */}

      {!!routeSummary.length && (

        <div className="bg-base-100 p-4 rounded shadow mb-6">

          <div className="font-semibold mb-2">Resumen por ruta (unidades)</div>

          <div className="flex flex-wrap gap-2">

            {routeSummary.slice(0, 12).map((r) => {

              const [from, to] = String(r.route).split("->");

              const label = `${SUCURSALES[from] || from} → ${SUCURSALES[to] || to}`;

              return (

                <span key={r.route} className="badge badge-outline">

                  {label}: <b className="ml-1">{fmt(r.qty)}</b>

                </span>

              );

            })}

          </div>

        </div>

      )}



      {/* Paginación */}

      <div className="flex items-center gap-2 mb-3">

        <button className="btn btn-sm btn-outline" onClick={() => setPage(1)} disabled={pages.p === 1}>

          {"<<"}

        </button>

        <button

          className="btn btn-sm btn-outline"

          onClick={() => setPage((p) => Math.max(1, p - 1))}

          disabled={pages.p === 1}

        >

          {"<"}

        </button>

        <div className="text-sm opacity-70">

          Página <b>{pages.p}</b> de <b>{pages.maxPage}</b> — mostrando {fmt(pages.start + 1)} a{" "}

          {fmt(Math.min(filtered.length, pages.end))} de {fmt(filtered.length)}

        </div>

        <button

          className="btn btn-sm btn-outline"

          onClick={() => setPage((p) => Math.min(pages.maxPage, p + 1))}

          disabled={pages.p === pages.maxPage}

        >

          {">"}

        </button>

        <button className="btn btn-sm btn-outline" onClick={() => setPage(pages.maxPage)} disabled={pages.p === pages.maxPage}>

          {">>"}

        </button>

      </div>



      {/* Tabla principal */}

{/* Movimientos propuestos */}

<div className="bg-base-100 rounded shadow overflow-hidden mb-8">

<div className="p-4 border-b flex flex-wrap gap-3 items-center justify-between">

  <div>

    <h2 className="text-xl font-semibold">Movimientos propuestos</h2>

    <div className="text-sm opacity-70">

      Transfers sugeridos según ventas y stock actual

    </div>

  </div>



  <div className="flex gap-3 text-sm">

    <span className="badge badge-outline">

      Items: <b className="ml-1">{fmt(totals.rows)}</b>

    </span>

    <span className="badge badge-outline">

      Transfers: <b className="ml-1">{fmt(totals.transfers)}</b>

    </span>

    <span className="badge badge-outline">

      Unidades: <b className="ml-1">{fmt(totals.unitsToMove)}</b>

    </span>

  </div>

</div>





    <div className="overflow-x-auto overflow-y-auto max-h-[70vh]">

  <table className="table table-zebra w-full">

          <thead className="sticky top-0 z-10 bg-base-100">

  <tr>

    <th className="w-12"></th>

    <th>SKU</th>

    <th>Descripción</th>

    <th>Ventas {Number(windowDays) || 30}d</th>

    <th>Stock</th>

    <th>Ideal</th>

    <th>Mover</th>

    <th>Transfers</th>

    <th className="text-right">Detalle</th>

  </tr>

</thead>

            <tbody>

              {paged.map((it) => {

                const pk = clampStr(it.productKey || it.id);

                const sku = clampStr(it.sku);

                const desc = clampStr(it.descripcionDisplay || it.descripcion);



                const v1 = safeNum(it.salesBySuc?.["1"], 0);

                const v2 = safeNum(it.salesBySuc?.["2"], 0);

                const v3 = safeNum(it.salesBySuc?.["3"], 0);



                const s1 = safeNum(it.stockBySuc?.["1"], 0);

                const s2 = safeNum(it.stockBySuc?.["2"], 0);

                const s3 = safeNum(it.stockBySuc?.["3"], 0);



                // const t1 = safeNum(it.targetBySuc?.["1"], 0);

                // const t2 = safeNum(it.targetBySuc?.["2"], 0);

                // const t3 = safeNum(it.targetBySuc?.["3"], 0);



                // const mk1 = safeNum(it.minKeepBySuc?.["1"], 0);

                // const mk2 = safeNum(it.minKeepBySuc?.["2"], 0);

                // const mk3 = safeNum(it.minKeepBySuc?.["3"], 0);



                const d1 = safeNum(it.desiredBySuc?.["1"], 0);

const d2 = safeNum(it.desiredBySuc?.["2"], 0);

const d3 = safeNum(it.desiredBySuc?.["3"], 0);



                const move = safeNum(it.totalSuggestedMove, sumTransfersQty(it));

                const trStr = transfersToString(it);



                const expanded = expandedPk === pk;

                const checked = selected.has(pk);



                return (

                  <React.Fragment key={pk}>

                    <tr>

                      <td>

                        <input

                          type="checkbox"

                          className="checkbox checkbox-success checkbox-sm"

                          checked={checked}

                          onChange={() => toggleSelected(pk)}

                          title="Seleccionar este movimiento"

                        />

                      </td>

                      <td className="font-mono text-xs">
                        <div>{sku || "-"}</div>
                        {it.cb ? <div className="opacity-70 mt-1">CB: {String(it.cb)}</div> : null}
                      </td>

                      <td>

                        <div className="font-semibold">{desc || "-"}</div>

             <div className="text-xs opacity-70">

  PK: {pk} {it.laboratorio ? `· LAB: ${it.laboratorio}` : ""}

</div>

                      </td>

                      <td className="text-sm">

                        {SUCURSALES["1"]}: <b>{fmt(v1)}</b> · {SUCURSALES["2"]}: <b>{fmt(v2)}</b> · {SUCURSALES["3"]}:{" "}

                        <b>{fmt(v3)}</b>

                      </td>

                      <td className="text-sm">

                        {SUCURSALES["1"]}: <b>{fmt(s1)}</b> · {SUCURSALES["2"]}: <b>{fmt(s2)}</b> · {SUCURSALES["3"]}:{" "}

                        <b>{fmt(s3)}</b>

                      </td>

                      {/* <td className="text-sm">

                        {SUCURSALES["1"]}: <b>{fmt(t1)}</b> · {SUCURSALES["2"]}: <b>{fmt(t2)}</b> · {SUCURSALES["3"]}:{" "}

                        <b>{fmt(t3)}</b>

                      </td>

                      <td className="text-sm">

                        {SUCURSALES["1"]}: <b>{fmt(mk1)}</b> · {SUCURSALES["2"]}: <b>{fmt(mk2)}</b> · {SUCURSALES["3"]}:{" "}

                        <b>{fmt(mk3)}</b>

                      </td>

                       */}

                       <td className="text-sm">

  {SUCURSALES["1"]}: <b>{fmt(d1)}</b> · {SUCURSALES["2"]}: <b>{fmt(d2)}</b> · {SUCURSALES["3"]}:{" "}

  <b>{fmt(d3)}</b>

</td>

                      <td className="text-sm">

                        <span className="badge badge-outline">

                          <b>{fmt(move)}</b>

                        </span>

                      </td>

                      <td className="max-w-[380px]">

                        <div className="truncate text-sm opacity-80">{trStr || "-"}</div>

                      </td>

                      <td className="text-right">

                        <button className="btn btn-sm" onClick={() => setExpandedPk(expanded ? "" : pk)}>

                          {expanded ? "Ocultar" : "Ver"}

                        </button>

                      </td>

                    </tr>



                    {expanded && (

                      <tr>

                        <td colSpan={9}>

                          <div className="p-3 bg-base-200/30 rounded">

                            <div className="flex flex-wrap gap-3 mb-3">

                        <StatCard title={`Ventas total (${Number(it.windowDays) || Number(windowDays) || 30}d)`} value={fmt(it.salesTotal)} />

                              <StatCard title="Stock total" value={fmt(it.stockTotal)} />

                              <StatCard title="Ventana / KeepDays" value={`${it.windowDays || "-"} / ${it.keepDays || "-"}`} />

                              <StatCard title={`Piso ventas (${it.reserveSalesDays || 0}d)`} value={`${fmt(it.minNeedBySuc?.["1"] || 0)} / ${fmt(it.minNeedBySuc?.["2"] || 0)} / ${fmt(it.minNeedBySuc?.["3"] || 0)}`} />

                            </div>



                            <div className="font-semibold mb-2">Transfers sugeridas</div>



                            {Array.isArray(it.transfers) && it.transfers.length ? (

                              <div className="overflow-x-auto">

                                <table className="table table-compact w-full">

                                  <thead>

                                    <tr>

                                      <th>Origen</th>

                                      <th>Destino</th>

                                      <th>Cantidad</th>

                                    </tr>

                                  </thead>

                                  <tbody>

                                    {it.transfers.map((t, idx) => (

                                      <tr key={idx}>

                                        <td>

                                          {SUCURSALES[String(t.fromSuc)] || t.fromSuc} ({t.fromSuc})

                                        </td>

                                        <td>

                                          {SUCURSALES[String(t.toSuc)] || t.toSuc} ({t.toSuc})

                                        </td>

                                        <td>

                                          <b>{fmt(t.qty)}</b>

                                        </td>

                                      </tr>

                                    ))}

                                  </tbody>

                                </table>

                              </div>

                            ) : (

                              <div className="opacity-70 text-sm">Sin transfers</div>

                            )}

                          </div>

                        </td>

                      </tr>

                    )}

                  </React.Fragment>

                );

              })}



              {!paged.length && (

                <tr>

                  <td colSpan={9} className="text-center opacity-70">

                    {itemsLoading ? "Cargando items..." : "No hay resultados con esos filtros."}

                  </td>

                </tr>

              )}

            </tbody>

          </table>

        </div>

      </div>



      {/* Historial guardados */}

      <div className="bg-base-100 p-4 rounded shadow">

        <div className="flex items-center justify-between mb-3">

          <h2 className="text-xl font-semibold">Historial de movimientos guardados</h2>

          <div className="text-sm opacity-70">{savedLoading ? "Cargando..." : `Últimos ${savedList.length}`}</div>

        </div>



        {!savedLoading && !savedList.length && <div className="opacity-70">No hay guardados todavía.</div>}



        {!!savedList.length && (

    <div className="overflow-x-auto overflow-y-auto max-h-[70vh]">

  <table className="table table-zebra w-full">

            <thead className="sticky top-0 z-10 bg-base-100">



                <tr>

                  <th>Fecha</th>

                  <th>Run</th>

                  <th>Items</th>

                  <th>Transfers</th>

                  <th>Unidades</th>

                  <th className="text-right">Acciones</th>

                </tr>

              </thead>

              <tbody>

                {savedList.map((m) => {

                  const dt = m.createdAt ? new Date(m.createdAt) : null;

                  const when = dt ? dt.toLocaleString("es-AR") : "-";

                  return (

                    <tr key={m.id}>

                      <td className="text-sm">{when}</td>

                      <td className="text-sm font-mono">{m.runId || "-"}</td>

                      <td className="text-sm">{fmt(m?.totals?.rows)}</td>

                      <td className="text-sm">{fmt(m?.totals?.transfers)}</td>

                      <td className="text-sm">{fmt(m?.totals?.unitsToMove)}</td>

                      <td className="text-right">

                        <div className="flex justify-end gap-2 flex-wrap">

                          <button className="btn btn-sm" onClick={() => loadSavedSelection(m.id)}>

                            Cargar selección

                          </button>

                          <button className="btn btn-sm btn-outline" onClick={() => exportSavedCSVs(m.id, "resumen")}>

                            CSV resumen

                          </button>

                          <button className="btn btn-sm btn-outline" onClick={() => exportSavedCSVs(m.id, "picking")}>

                            CSV picking

                          </button>

                        </div>

                      </td>

                    </tr>

                  );

                })}

              </tbody>

            </table>

          </div>

        )}



      </div>

    </div>

  );

}



/* ===================== UI small ===================== */



function StatCard({ title, value }) {

  return (

    <div className="border rounded p-3 bg-base-100 min-w-[180px]">

      <div className="text-xs opacity-70">{title}</div>

      <div className="text-lg font-bold">{value}</div>

    </div>

  );

}
